import { Flex, Text } from '@chakra-ui/react';

export const CorrespondingAuthorEmptyState = () => {
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      color="neutralSecondaryContent"
      py={3}
    >
      <Flex alignItems="center" gap={2} flexDirection="row">
        <Text textStyle="textBody">No data available</Text>
      </Flex>
    </Flex>
  );
};
